<template>
    <div v-if="dialogState" class="hk-dialog-container">
        <div class="hk-dialog flex flex-column flex-between flex-vertical-center">
            <i class="el-icon-close close-dialog" @click="handleCancel"></i>
            <div class="hk-dialog-title">{{ title }}</div>
            <div class="hk-dialog-content">
                <slot name="content">这是提示语句</slot>
            </div>
            <slot name="footer">
                <hk-button
                    :text="buttonText"
                    :customStyle="buttonStyle"
                    @handleClick="handleClick"
                ></hk-button>
            </slot>
        </div>
    </div>
</template>

<script>
import HkButton from '@components/HkButton';
export default {
    name: 'HkDialog',
    components: {
        HkButton
    },
    props: {
        state: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '提示'
        },
        buttonText: {
            type: String,
            default: '确定'
        }
    },
    data() {
        return {
            buttonStyle: {
                width: '110px',
                color: '#fff',
                shadowColor: '#FFC8A4',
                background: true,
                startColor: '#FF7B1A',
                endColor: '#FFA11A'
            },
            dialogState: false
        };
    },
    watch: {
        state: {
            handler: function (val, oldVal) {
                this.dialogState = val;
            },
            immediate: true
        }
    },
    created() {},
    mounted() {},
    methods: {
        handleCancel() {
            this.$emit('close');
        },
        handleClick() {
            this.$emit('confirm');
        }
    }
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.hk-dialog-container {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 999;
    .hk-dialog {
        box-sizing: border-box;
        width: 556px;
        min-height: 205px;
        background: url('~@images/base/message-bg2.png') no-repeat center bottom #ffff;
        background-size: 100% auto;
        border-radius: 20px;
        position: absolute;
        top: 200px;
        left: 50%;
        margin-left: -278px;
        padding: 30px 70px;
        .close-dialog {
            font-size: 14px;
            color: #636363;
            position: absolute;
            right: 20px;
            top: 20px;
            cursor: pointer;
            user-select: none;
        }
        &-title {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 800;
            color: #333;
            text-align: center;
            margin-bottom: 15px;
        }
        &-content {
            text-align: center;
        }
    }
}
</style>
